// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    CartResult,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/SaveOrder";
import { CustomAppState } from "@rugby/App/Store/Reducers";

type SaveOrderParameter = HasOnError<string> & HasOnSuccess<string>;

type HandlerType = ApiHandlerDiscreteParameter<SaveOrderParameter, UpdateCartApiParameter, CartResult>;

export const XngPopulateApiParameter: HandlerType = props => {
    const state = props.getState() as CustomAppState;
    const cart = getCurrentCartState(state).value;
    const { editedCartNotes } = state.pages.checkoutShipping;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to save the current cart.");
    }

    const notes = typeof editedCartNotes === "undefined" ? cart.notes : editedCartNotes;
    const poNumber = state?.xCheckout?.cart?.poNumber;

    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            poNumber,
            notes,
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter)